import styled from "styled-components";
import { siteDarkBlue } from "../../providers/Theme";

export const Card = styled.div`
  background: white;
  border: 1.5px solid #dde2ee;
  border-radius: 12px;
  padding: 1.75rem 1.5rem;
  display: flex;
  flex-direction: column;
`;

export const PhotoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const Photo = styled.img`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center top;
  flex-shrink: 0;
`;

export const PhotoPlaceholder = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #dde2ee;
  flex-shrink: 0;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.h3`
  color: ${siteDarkBlue};
  font-weight: 700;
  font-size: 1.1rem;
  margin: 0 0 0.15rem;
  line-height: 1.3;
`;

export const Role = styled.p<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0 0 0.15rem;
`;

export const Subtitle = styled.p`
  color: ${siteDarkBlue};
  font-style: italic;
  font-size: 0.875rem;
  margin: 0;
`;

export const HighlightsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const HighlightItem = styled.li<{ $color: string }>`
  color: ${siteDarkBlue};
  font-size: 0.875rem;
  line-height: 1.5;
  padding-left: 0.85rem;
  border-left: 3px solid ${({ $color }) => $color};
`;

export const Bio = styled.p`
  color: ${siteDarkBlue};
  font-size: 0.9rem;
  line-height: 1.65;
  margin: 0;
  flex: 1;
`;
